var React = require('react');

function Walker (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 448a64 64 0 1 1-64-64 64 64 0 0 1 64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 357.47a96.34 96.34 0 0 1 64 0V96a96 96 0 0 0-96-96H190.66A95.62 95.62 0 0 0 96 80L.24 487.77a16 16 0 0 0 13 18.51l31.54 5.48a16 16 0 0 0 18.5-13L127.81 224H352zM142.83 160l16.26-69.25A31.91 31.91 0 0 1 190.66 64H320a32 32 0 0 1 32 32v64z","className":"fa-primary","key":2})]);
}

Walker.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Walker;

Walker.default = Walker;
